import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenCheck, MousePointerClick, SlidersHorizontal } from 'lucide-react';

const steps = [
  {
    icon: SlidersHorizontal,
    title: 'Ustaw swoje kryteria',
    description:
      'Załóż konto, wybierz źródła ogłoszeń, lokalizację, zakres cen i rodzaje powiadomień.',
  },
  {
    icon: BookOpenCheck,
    title: 'Dodaj cennik',
    description:
      'Wpisz ceny skupu lub sprzedaży dla konkretnych modeli, pamięci i stanu urządzenia.',
  },
  {
    icon: MousePointerClick,
    title: 'Wybierz najlepszą ofertę',
    description:
      'Przeglądaj posortowane wyniki, sprawdzaj szacowaną marżę i przechodź do ogłoszenia źródłowego.',
  },
] as const;

const HowItWorks: React.FC = () => (
  <section id="jak-dziala" className="scroll-mt-24 px-4 py-20 sm:py-24">
    <div className="mx-auto max-w-7xl rounded-[32px] border border-white/[0.08] bg-white/[0.025] px-5 py-12 sm:px-10 lg:px-14">
      <div className="mb-12 max-w-2xl">
        <p className="section-eyebrow">Prosty proces</p>
        <h2 className="section-title">Trzy kroki do szybszej oceny ogłoszeń.</h2>
        <p className="section-copy">
          iPhoneFastFlip nie podejmuje decyzji za Ciebie. Porządkuje dane i skraca czas potrzebny na znalezienie pozycji wartej dokładniejszego sprawdzenia.
        </p>
      </div>

      <div className="grid gap-5 lg:grid-cols-3">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <motion.article
              key={step.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative rounded-2xl border border-white/[0.08] bg-[#0d121d]/80 p-6"
            >
              <div className="mb-7 flex items-center justify-between">
                <div className="grid h-12 w-12 place-items-center rounded-xl bg-blue-500/10 text-blue-300">
                  <Icon className="h-6 w-6" />
                </div>
                <span className="text-4xl font-black text-white/[0.06]">0{index + 1}</span>
              </div>
              <h3 className="text-xl font-bold text-white">{step.title}</h3>
              <p className="mt-3 text-sm leading-6 text-slate-400">{step.description}</p>
            </motion.article>
          );
        })}
      </div>
    </div>
  </section>
);

export default HowItWorks;
